export default [
  {
    type: 'selection',
    width: 55,
    show: true,
  },
  {
    title: '编号',
    key: 'id',
    minWidth: 40,
    maxWidth: 100,
    show: true,
  },

  {
    title: '国家简称',
    key: 'name_cn',
    slot: 'name_cn',
    minWidth: 140,
    show: true,
  },
  {
    title: '英文简写',
    key: 'short',
    slot: 'short',
    minWidth: 140,
    show: true,
  },

  {
    title: '状态',
    key: 'status',
    slot: 'status',
    minWidth: 100,
    show: true,
  },
  {
    title: '操作',
    key: 'action',
    slot: 'action',
    minWidth: 120,
    maxWidth: 160,
    align: 'center',
    fixed: 'right',
    show: true,
  },
]
